import React, { useState, useEffect } from "react";
import RiskEdit from "../RiskEdit";
import PropTypes from "prop-types";
import APIService from "../../../../services/apiAxiosService";
import useHttp from "../../../../hooks/useHttp";
import {Table, Column} from "@appkit4/react-components/table";
import { Input } from "@appkit4/react-components/field";
import { Pagination } from "@appkit4/react-components/pagination";
export default function AllRisk(props) {
  const [createRiskTab, setCreateRiskTab] = useState(false);
  const [updateBusinessAnalysis, setUpdateBusinessAnalysis] = useState({});
  const [tableData, setTableData] = useState([]);
  const [search, setSearch] = useState("");
  const [filter, setFilter] = useState([]);
  const [current, setCurrent] = useState(1);
  const [totalPage, setTotalPage] = useState(500);
  const { sendRequest: getBusinessImpactByID } = useHttp();
  let {
    BusinesssAnalysis,
    loading,
    vendors,
    classifications,
    reload,
    businessUsers,
  } = props;

  function approvalRejectionStatus(id) {
    let returnMessage = ""
    switch(id) {
      case 1:
        returnMessage = "Created by assessor"
        break;
      case 2:
        returnMessage = "Approved by assessor"
        break;
      case 3:
        returnMessage = "Approved by manager"
        break;
      case 4:
        returnMessage = "Rejected by assessor"
        break;
      case 5:
        returnMessage = "Rejected by manager"
        break;
    }
    return(returnMessage)
  }

  const handleBack = () => {
    setCreateRiskTab(false);
    setTableData(BusinesssAnalysis);
    setFilter(BusinesssAnalysis);
    let totalPageLength = Math.ceil((BusinesssAnalysis?.length)/10);
      if (totalPageLength === 0) {
        totalPageLength = 1;
      }
    setTotalPage(totalPageLength);
  };

  useEffect(() => {
    setTableData(BusinesssAnalysis);
    setFilter(BusinesssAnalysis);
    let totalPageLength = Math.ceil((BusinesssAnalysis?.length)/10);
      if (totalPageLength === 0) {
        totalPageLength = 1;
      }
    setTotalPage(totalPageLength);
  }, [BusinesssAnalysis]);

  const getBusinessAnalysis = async (bIARiskId) => {
    getBusinessImpactByID(APIService.getBusinessImpactByID(bIARiskId), (result) => {
      setUpdateBusinessAnalysis(result.MSG[0]);
      setCreateRiskTab(true);
    });
  };

  useEffect(() => {
    const result = tableData?.filter((manageRiskList) => {
      let searchParam = `RISK${manageRiskList?.risk_id.toString()}`
      return searchParam.toLowerCase().match(search.toLocaleLowerCase());
    });
    setFilter(result);
  }, [search]);
  
  if (loading) {
    return (
      <div className="a-loading a-primary a-m-10 a-loading-24 spinner-alignment"></div>
    );
  }

  const sortFuncForOrder1 = (a, b) => {
    const firstOrderId = (a.risk_id.toString()).charAt(1);
    const secondOrderId = (b.risk_id.toString()).charAt(1);
    return firstOrderId > secondOrderId ? 1 : -1;;
}

  const sortFuncForOrder2 = (a, b) => {
    const firstOrderId = (a.risk_id.toString()).charAt(1);
    const secondOrderId = (b.risk_id.toString()).charAt(1);
    return firstOrderId < secondOrderId ? 1 : -1;;
  }

  const renderRiskID = (row) => {
    let riskID = "RISK"+row?.risk_id;
  return <div>{riskID}</div>
  }

  const renderStatusCell = (row) => {
    let stylesClass;
    switch (row._status) {
      case "Expired":
      stylesClass = "Expired-status";
      break;
      case "Open":
      stylesClass = "Open-status";
      break;
      case "Close":
      stylesClass = "Close-status";
      break;
      default:
      stylesClass = "";
    }
    let className = "bia-status " + stylesClass;
    return <div className={className}>{row._status}</div>
  }

  const renderApprovalStatus = (row) => {
    return approvalRejectionStatus(row?.approval_requests);
  }

  const renderActionCell = (row) => {
    return (
      <>
        <span className=" Appkit4-icon icon-edit-fill action-icon pointer" title="Edit request" onClick={() => handleEditButton(row)}></span>&nbsp;
        <span className=" Appkit4-icon icon-delete-fill action-icon pointer" title="Delete request"></span>
      </>
    )
  }

  const handleEditButton = (row) => {
    getBusinessAnalysis(row?.risk_id);
  }

  return (
    <div className="App">
      {createRiskTab ? (
        <RiskEdit
          handleBack={handleBack}
          reload={reload}
          vendors={vendors}
          classifications={classifications}
          updateBusinessAnalysis={updateBusinessAnalysis}
          businessUsers={businessUsers}
        />
      ) : (
        <div className="col-lg-12 mt-3 pl-1">
          {tableData.length > 0 ? (
            <Input
            type="text"
            title= "Search Risk ID"
            value={search}
            className="ap-field-wrapper-tableSearch"
            onChange={(e) => setSearch(e)}
          /> 
          ) : ""}
              <div className="ap-table-demo">
                <Table originalData={filter} hasTitle currentPage={current} pageSize={10} className={filter.length === 0 ? "" : "biaTableBU"}>
                    <Column field="risk_id" sortKey={filter.length > 0 ? "risk_id" : ""} sortFunc1={sortFuncForOrder1} sortFunc2={sortFuncForOrder2} renderCell={renderRiskID} className={filter.length === 0 ? "" : "oneFifty"}>Risk ID</Column>
                    <Column field="vendor_name" sortKey={filter.length > 0 ? "vendor_name" : ""} className={filter.length === 0 ? "" : "twoHundred"}>Third Party Name</Column>
                    <Column field="_status" sortKey={filter.length > 0 ? "_status" : ""} renderCell={renderStatusCell}>Status</Column>
                    <Column field="approval_requests" sortKey={filter.length > 0 ? "approval_requests" : ""} renderCell={renderApprovalStatus} className={filter.length === 0 ? "" : "twoThirty"}>Approval/ Rejection Status</Column>
                    <Column field="service_name" sortKey={filter.length > 0 ? "service_name" : ""} className={filter.length === 0 ? "" : "oneFifty"}>Service Name</Column>
                    <Column field="business_owner" sortKey={filter.length > 0 ? "business_owner" : ""} className={filter.length === 0 ? "" : "twoHundred"}>Business Owner</Column>
                    <Column field="date_issued" sortKey={filter.length > 0 ? "date_issued" : ""} className={filter.length === 0 ? "" : "oneFifty"}>Date Issued</Column>
                    <Column field="information_classification" sortKey={filter.length > 0 ? "information_classification" : ""} className={filter.length === 0 ? "" : "twoThirty"}>Information Classification</Column>
                    <Column field="duration" sortKey={filter.length > 0 ? "duration" : ""}>Duration</Column>
                    <Column field="expiray_date" sortKey={filter.length > 0 ? "expiray_date" : ""}>Expiry</Column>
                    <Column field="risk_id"
                    className={filter.length === 0 ? "" : "oneFifty"}
                    renderCell={renderActionCell}
                    >Action</Column>
                </Table>
                {filter.length === 0 ? (
                  <div className="noData">
                  No data available in table
                  </div>
                  ) : ("")}
                  </div>
                <Pagination
                  defaultCurrent={1}
                  current={current}
                  total={totalPage}
                  onPageChange={(page) => setCurrent(page)}
                >
                </Pagination>
            </div>
      )}
    </div>
  );
}

AllRisk.propTypes = {
  BusinesssAnalysis: PropTypes.any,
  loading: PropTypes.any,
  vendors: PropTypes.any,
  classifications: PropTypes.any,
  reload: PropTypes.any,
  businessUsers: PropTypes.any,
  reset: PropTypes.any
}
